import { Box, Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getBeautifiedLocalDate } from '@/core';
import { useDetailContext } from '../contexts/DetailContext';

const Details = () => {
  const { t } = useTranslation();
  const { data } = useDetailContext();

  return (
    <Grid container spacing={3}>
      <Grid item md>
        <List sx={{ display: 'flex', flexDirection: 'column' }}>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Status', { defaultValue: 'Status' })}
              secondary={data.status || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Start date', { defaultValue: 'Start date' })}
              secondary={data?.datStart ? getBeautifiedLocalDate(data.datStart) : '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Note for auditors', { defaultValue: 'Note for auditors' })}
              secondary={data.noteForAuditors || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Is multisite?', { defaultValue: 'Is multisite?' })}
              secondary={data.isMultisite || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Number of employess', { defaultValue: 'Number of employess' })}
              secondary={data.numOfEmployees || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Planned time', { defaultValue: 'Planned time' })}
              secondary={data.planedTime || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Proposed time', { defaultValue: 'Proposed time' })}
              secondary={data.proposedTime || '/'}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={t('Time confirmation date', { defaultValue: 'Time confirmation date' })}
              secondary={data.datConf ? getBeautifiedLocalDate(data.datConf) : '/'}
            />
          </ListItem>
        </List>
      </Grid>
      <Grid item md>
        <Box>
          <List
            subheader={
              <Typography variant="h5" sx={{ padding: '8px 16px' }}>
                {t('Services', { defaultValue: 'Services' })}
              </Typography>
            }
          >
            {!!data.services &&
              data.services.map((service) => (
                <ListItem key={service.id} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: '1.25rem' }}
                    secondaryTypographyProps={{ fontSize: '1rem' }}
                    primary={service.serviceShowAs}
                    secondary={
                      <Box>
                        <Typography sx={{ fontSize: '1rem', fontWeight: '500' }}>
                          {t('Standard', { defaultValue: 'Standard' })}:{' '}
                          {service.processStandard || 'N/A'}
                        </Typography>
                        <Typography>
                          {t('Note', { defaultValue: 'Note' })}: {service.note || 'N/A'}
                        </Typography>
                        <Typography>
                          {t('Scope of work', { defaultValue: 'Scope of work' })}:{' '}
                          {service.scopeOfWork || 'N/A'}
                        </Typography>
                        <Typography>
                          {t('Scope confirmed', { defaultValue: 'Scope confirmed' })}:{' '}
                          {service.scopeConfirmed || 'N/A'}
                        </Typography>
                        {service?.scopeNotes && (
                          <Typography>
                            {t('Scope notes', { defaultValue: 'Scope notes' })}:{' '}
                            {service.scopeNotes || 'N/A'}
                          </Typography>
                        )}
                        {service.srvNotes && (
                          <Typography>
                            {t('Note', { defaultValue: 'Note' })}: {service.srvNotes}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </ListItem>
              ))}
          </List>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Details;
